import React, { useEffect, useState } from "react";
import { Redirect, useHistory } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import InputMask from "react-input-mask";
import { URLBunge } from "./Componentes/Config";
import {
  AlertForm,
  AlertFormComTitulo,
  maskLoginSympla,
  MostrarIngresso,
  hexToRgbA,
} from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import Rodape from "./Componentes/Rodape";

import {
  BackgroundImg,
  Coluna,
  CampoForm,
  FormLogin,
  BotaoEntrar,
  LogoMinhaBunge,
  IcoForm,
  BtEsqueciSenha,
  Clear,
  LogoBunge,
  BotaoCadastro,
  FooterLogin,
} from "./Estilos";

import ImgLogoMinhaBunge from "./Images/LogoMinhaBunge.png";
import BackgroundPagina from "./Images/BgBunge.jpg";
import ImgIcoEnvelope from "./Images/ico_envelope.png";
import ImgIcoCadeado from "./Images/ico_cadeado.png";
import ImgLogoBunge from "./Images/LogoBunge.png";

function Login() {
  const history = useHistory();
  const [Loading, setLoading] = useState(false);
  const { register, handleSubmit, errors, control, setValue } = useForm();

  const [NomeEvento, setNomeEvento] = useState("Minha Bunge Vendas");
  const [IpClient, SetIpClient] = useState("");
  const [EmailInvalido, setEmailInvalido] = useState(false);
  const [resetSenha, setResetSenha] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("c_token");
    if (token != "null" && token != null) {
      console.log("TESTE TOKEN: ", token)
      history.push("home");
    }
  }, []);

  const onSubmit = async (data, e) => {
    setLoading(true);

    if (data.c_email == "" || data.c_email == undefined) {
      //console.log('passou');
      AlertForm("O campo E-MAIL é de preenchimento obrigatório!");
      setLoading(false);
      e.preventDefault();
    } else if (
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        data.c_email
      )
    ) {
      if (data.c_email !== "" && data.c_email !== undefined) {
        setLoading(true);

        const response = await fetch(URLBunge + "/api/Logon/AppBungeLogon", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            idProjeto: 0,
            email: data.c_email.toLowerCase(),
            senha: data.c_senha,
          }),
        });

        const result = await response.json();

        // VISÃO TRADE
        // jessica.camara@bunge.com
        // var token = "eyJhbGciOiJSUzI1NiIsImtpZCI6IkY3NEM3NEEyRkRDOTJBMEVEMUEwRjZEMUUyMDVBQjlGOTcxNDM4OTUiLCJ0eXAiOiJKV1QiLCJ4NXQiOiI5MHgwb3YzSktnN1JvUGJSNGdXcm41Y1VPSlUifQ.eyJuYmYiOjE2MzE3MDkzNjUsImV4cCI6MTk0NzA2OTM2NSwiaXNzIjoiaHR0cDovL2xvY2FsaG9zdDo4MDk0IiwiYXVkIjpbImh0dHA6Ly9sb2NhbGhvc3Q6ODA5NC9yZXNvdXJjZXMiLCJhcHBidW5nZUdXIiwiY2F0YWxvZ29HVyIsIm9tbmlvbkdXIl0sImNsaWVudF9pZCI6IkFwcEJ1bmdlQ2xpZW50Iiwic3ViIjoiNWNiYTljMjAtMDBjMC00YjU1LTRkZDMtMDhkN2Q2NzFmNmQ1IiwiYXV0aF90aW1lIjoxNjMxNzA5MzYzLCJpZHAiOiJsb2NhbCIsIkZ1bGxOYW1lIjoiICIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL25hbWVpZGVudGlmaWVyIjoiNWNiYTljMjAtMDBjMC00YjU1LTRkZDMtMDhkN2Q2NzFmNmQ1IiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvbmFtZSI6IjAxODI3Nzc2MTg4Iiwic2NvcGUiOlsiYXBpYXBwYnVuZ2UiLCJhcGljYXRhbG9nbyIsImFwaW9tbmlvbiIsIm9mZmxpbmVfYWNjZXNzIl0sImFtciI6WyJwd2QiXX0.iSSbiUlA7X2xD3wDHGV94ogdAFtGC_pj5sPNu3ue1wTpHLfvHVlXdIdR38KO1cXU-ef0mhEP9R1ZtBeo-qnWwuut5-kWZXxh-h6DRkJphreu-CF6Gi3KsQXwTOj6NzNES9xFD_3Rv6pWebQ7FP5ZpyfnouUPD3brF7UBPRbEis2bPiUIGoiP1MnMXnNdLEh8NVfC6qks_yo-CWLkDgD2KsPw32fcP5OYb3PIqE-CP6bZA1uX2vd4hum6NrM5NDUzwdT6uxe9X5jfTf4hJv2dtBfUbLZXo1RFjQ1qWQFAMRpn2jCTDEZiY-O9ymj7OaOozJgUzBNRwz3taq_BQhcaFA";

        var token = result.token;
        localStorage.setItem("c_token", token);
        console.log(result);

        if (result.sucesso === true) {
          var myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");
          myHeaders.append("Authorization", "bearer " + token);

          const ListarClienteDoc = await fetch(
            URLBunge + "/api/Cliente/ListarClienteDoc",
            {
              method: "GET",
              headers: myHeaders,
              redirect: "follow",
            }
          );

          const resultListarClienteDoc = await ListarClienteDoc.json();
          // console.log(resultListarClienteDoc);

          localStorage.setItem(
            "id_tb_user",
            resultListarClienteDoc.idCliente.toString()
          );
          localStorage.setItem("c_nome", resultListarClienteDoc.nome);
          localStorage.setItem("c_apelido", resultListarClienteDoc.apelido);
          localStorage.setItem("c_email", resultListarClienteDoc.email);
          localStorage.setItem(
            "c_telefone",
            resultListarClienteDoc.dddFixo +
              "" +
              resultListarClienteDoc.telefoneFixo
          );
          localStorage.setItem(
            "c_celular",
            resultListarClienteDoc.dddCelular +
              "" +
              resultListarClienteDoc.celular
          );
          localStorage.setItem("c_cpf", resultListarClienteDoc.cpf);
          localStorage.setItem("c_cep", resultListarClienteDoc.cep);
          localStorage.setItem("c_endereco", resultListarClienteDoc.rua);
          localStorage.setItem(
            "c_numero",
            resultListarClienteDoc.numero.toString()
          );
          localStorage.setItem(
            "c_complemento",
            resultListarClienteDoc.complemento
          );
          localStorage.setItem("c_bairro", resultListarClienteDoc.bairro);
          localStorage.setItem("c_cidade", resultListarClienteDoc.cidade);
          localStorage.setItem("c_estado", resultListarClienteDoc.estado);
          localStorage.setItem(
            "c_tipo",
            resultListarClienteDoc.tipo.toString()
          );
          localStorage.setItem(
            "c_cargo",
            resultListarClienteDoc.cargo.toString()
          );

          localStorage.setItem(
            "c_avatar_topType",
            resultListarClienteDoc.avatar[0].produto
          );
          localStorage.setItem(
            "c_avatar_accessoriesType",
            resultListarClienteDoc.avatar[1].produto
          );
          localStorage.setItem(
            "c_avatar_hatColor",
            resultListarClienteDoc.avatar[2].produto
          );
          localStorage.setItem(
            "c_avatar_hairColor",
            resultListarClienteDoc.avatar[3].produto
          );
          localStorage.setItem(
            "c_avatar_facialHairType",
            resultListarClienteDoc.avatar[4].produto
          );
          localStorage.setItem(
            "c_avatar_facialHairColor",
            resultListarClienteDoc.avatar[5].produto
          );
          localStorage.setItem(
            "c_avatar_clotheType",
            resultListarClienteDoc.avatar[6].produto
          );
          localStorage.setItem(
            "c_avatar_clotheColor",
            resultListarClienteDoc.avatar[7].produto
          );
          localStorage.setItem(
            "c_avatar_graphicType",
            resultListarClienteDoc.avatar[8].produto
          );
          localStorage.setItem(
            "c_avatar_eyeType",
            resultListarClienteDoc.avatar[9].produto
          );
          localStorage.setItem(
            "c_avatar_eyebrowType",
            resultListarClienteDoc.avatar[10].produto
          );
          localStorage.setItem(
            "c_avatar_mouthType",
            resultListarClienteDoc.avatar[11].produto
          );
          localStorage.setItem(
            "c_avatar_skinColor",
            resultListarClienteDoc.avatar[12].produto
          );

          localStorage.setItem(
            "id_avatar_topType",
            resultListarClienteDoc.avatar[0].produtoId.toString()
          );
          localStorage.setItem(
            "id_avatar_accessoriesType",
            resultListarClienteDoc.avatar[1].produtoId.toString()
          );
          localStorage.setItem(
            "id_avatar_hatColor",
            resultListarClienteDoc.avatar[2].produtoId.toString()
          );
          localStorage.setItem(
            "id_avatar_hairColor",
            resultListarClienteDoc.avatar[3].produtoId.toString()
          );
          localStorage.setItem(
            "id_avatar_facialHairType",
            resultListarClienteDoc.avatar[4].produtoId.toString()
          );
          localStorage.setItem(
            "id_avatar_facialHairColor",
            resultListarClienteDoc.avatar[5].produtoId.toString()
          );
          localStorage.setItem(
            "id_avatar_clotheType",
            resultListarClienteDoc.avatar[6].produtoId.toString()
          );
          localStorage.setItem(
            "id_avatar_clotheColor",
            resultListarClienteDoc.avatar[7].produtoId.toString()
          );
          localStorage.setItem(
            "id_avatar_graphicType",
            resultListarClienteDoc.avatar[8].produtoId.toString()
          );
          localStorage.setItem(
            "id_avatar_eyeType",
            resultListarClienteDoc.avatar[9].produtoId.toString()
          );
          localStorage.setItem(
            "id_avatar_eyebrowType",
            resultListarClienteDoc.avatar[10].produtoId.toString()
          );
          localStorage.setItem(
            "id_avatar_mouthType",
            resultListarClienteDoc.avatar[11].produtoId.toString()
          );
          localStorage.setItem(
            "id_avatar_skinColor",
            resultListarClienteDoc.avatar[12].produtoId.toString()
          );

          history.push({
            pathname: "home",
            state: {},
          });

          setLoading(false);
        }else if(result.isResetSenha){
          setResetSenha(true);
          AlertFormComTitulo(
            'Aviso!',
            'Por questões de segurança, sua senha precisa ser alterada. Por favor, solicite uma nova senha em Esqueci minha senha.'
          );
          setLoading(false);
        } else {
          AlertForm(result.mensagem);
          setLoading(false);
        }
      }
    } else {
      AlertForm("O campo E-MAIL está com o formato incorreto!");
      setLoading(false);
      e.preventDefault();
    }
  };

  const RecuperaSenha = async (data, e) => {
    console.log("passou");

    setLoading(true);
    setResetSenha(false);
    if (data.c_email == "" || data.c_email == undefined) {
      //console.log('passou');
      AlertForm("O campo E-MAIL é de preenchimento obrigatório!");
      setLoading(false);
      e.preventDefault();
    } else if (
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        data.c_email
      )
    ) {
      if (data.c_email !== "" && data.c_email !== undefined) {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const response = await fetch(
          URLBunge + "/api/EsqueceuSenha/EsqueceuSenha",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              email: data.c_email.toLowerCase(),
              tipoEmail: 3,
              remetente: "contato.fornada@omnion.com.br",
            }),
          }
        );

        const result = await response.json();
        // console.log(result);

        if (result.sucesso === true) {
          setLoading(false);
          AlertFormComTitulo(
            'E-mail enviado com sucesso!',
            'Caso não tenha recebido, verifique na sua caixa de SPAM.'
          );
        } else {
          AlertForm(result.mensagem);
          setLoading(false);
        }
      }
    } else {
      AlertForm("O campo E-MAIL está com o formato incorreto!");
      setLoading(false);
      e.preventDefault();
    }
  };

  return (
    <>      
      <CabecalhoPagina NomeEvento={NomeEvento} />

      {Loading === true ? <Carregando /> : null}

      <BackgroundImg
        Background={BackgroundPagina}
        BackgroundMob={BackgroundPagina}
        bgcolor={"#191919"}
      >
        <Coluna>
          <LogoMinhaBunge src={ImgLogoMinhaBunge} MaxWidth={"300px"} />

          <FormLogin onSubmit={handleSubmit(onSubmit)}>
            <CampoForm>
              <IcoForm src={ImgIcoEnvelope} />
              <Controller
                control={control}
                ref={register}
                id="c_email"
                name="c_email"
                type="text"
                placeholder={"E-mail"}
                className="CampoForm CampoFormLogin"
                as={InputMask}
                mask=""
              />
            </CampoForm>
            <CampoForm>
              <IcoForm src={ImgIcoCadeado} />
              <Controller
                control={control}
                ref={register}
                id="c_senha"
                name="c_senha"
                type="password"
                placeholder={"Senha"}
                className="CampoForm CampoFormLogin"
                as={InputMask}
                mask=""
              />
            </CampoForm>

            <BotaoEntrar type="submit">ENTRAR</BotaoEntrar>
            <Clear />
            <BtEsqueciSenha onClick={handleSubmit(RecuperaSenha)}>
              Esqueci minha senha
            </BtEsqueciSenha>
            <Clear />
          </FormLogin>

          <FooterLogin>
            <BotaoCadastro
              onClick={() => history.push({ pathname: "cadastro", state: {} })}
            >
              CADASTRO
            </BotaoCadastro>
            <Clear />
            <LogoBunge src={ImgLogoBunge} />
          </FooterLogin>
        </Coluna>
      </BackgroundImg>
    </>
  );
}

export default Login;
